const Nav = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-40 px-6 py-4 transition-all duration-300 backdrop-blur-sm border-b border-[#1F1F1F]/5" style={{ backgroundColor: 'rgba(244,241,234,0.8)' }}>
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 group cursor-pointer">
          <img 
            src="/image-3.svg" 
            alt="Logo" 
            className="w-10 h-10"
            style={{ filter: 'brightness(0)' }}
          />
          <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>Trippy</span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          <a href="#analysis" className="font-typewriter text-xs uppercase tracking-widest hover:text-[#b7eb6f] transition-colors">Анализ конкурентов</a>
          <a href="#styles" className="font-typewriter text-xs uppercase tracking-widest hover:text-[#b7eb6f] transition-colors">Стили</a>
          <a href="#watermark" className="font-typewriter text-xs uppercase tracking-widest hover:text-[#b7eb6f] transition-colors">Водяной знак</a>
        </div>

        <div className="flex items-center gap-4">
          <a href="https://trippika.ru/seller-login" className="hidden md:block font-typewriter text-xs uppercase tracking-widest underline decoration-[#b7eb6f] underline-offset-4 decoration-2">Войти</a>
          <a href="https://trippika.ru/seller-login" className="bg-[#1F1F1F] text-[#F4F1EA] px-6 py-2 rounded-full font-typewriter text-xs uppercase tracking-widest hover:bg-[#b7eb6f] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 inline-block">
            Начать бесплатно
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
